<template>
  <v-dialog v-model="state" max-width="600px" persistent>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>Xác nhận thao tác</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <v-textarea
              v-model="logNote"
              label="Ghi chú (nếu có)"
              placeholder="Bạn có muốn thêm ghi chú cho bước này không?"
              outlined
              hide-details
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-6 pb-6 pt-0">
        <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-4" dark @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    state: Boolean
  },
  data() {
    return {
      logNote: ''
    }
  },
  computed: {},
  methods: {
    confirm() {
      this.$emit('confirm', this.logNote)
    },

    cancel() {
      this.$emit('close')
    }
  }
}
</script>
